import { CardVariantsEnum } from "../../../../../../utils/dataTransform/ContentQueryWidget/types";
import CardCQW from "../../../../../CardCQW/component";

const CarouselPlaceholder = () => {
    const NUMBER_OF_PLACEHOLDER_CARDS = 5;
    const placeholderCards = [];

    for (let i = 0; i < NUMBER_OF_PLACEHOLDER_CARDS; i++) {
        placeholderCards.push(
            <li
                key={`card-placeholder-${i}`}
                className="cardContainer placeholder"
            >
                <CardCQW variant={CardVariantsEnum.CAROUSEL} />
            </li>
        );
    }

    return <ul data-testid={"placeholder-list"}>{placeholderCards}</ul>;
};

export default CarouselPlaceholder;
